// Helpers puros para las grabaciones de visitas/llamadas de un lead.
// Sin dependencias de React ni de red: fáciles de testear en aislamiento.

export const TYPE_LABELS = {
  visita: "Visita",
  llamada: "Llamada",
};

// Extensiones de audio conocidas (algunos navegadores móviles dejan el
// contentType vacío al elegir un archivo grabado en el teléfono).
const AUDIO_EXTENSIONS = [
  "m4a", "mp3", "mp4", "ogg", "oga", "opus", "wav", "aac",
  "amr", "3gp", "3gpp", "webm", "weba", "caf", "flac", "mpeg",
];

/**
 * Siguiente número correlativo para un tipo dado (independiente por tipo).
 * Usa max(index)+1 para no reutilizar números aunque se hayan borrado.
 */
export function computeNextIndex(recordings, type) {
  const list = Array.isArray(recordings) ? recordings : [];
  let max = 0;
  let count = 0;
  for (const r of list) {
    if (r && r.type === type) {
      count++;
      const idx = r.index != null ? Number(r.index) : count;
      if (idx > max) max = idx;
    }
  }
  return max + 1;
}

/**
 * Permisivo a propósito: aceptar cualquier audio/* o, si no hay contentType,
 * deducir por la extensión del nombre de archivo.
 */
export function isAudioFile(name, contentType) {
  if (typeof contentType === "string" && contentType.toLowerCase().startsWith("audio/")) {
    return true;
  }
  const ext = String(name || "").split(".").pop().toLowerCase();
  return AUDIO_EXTENSIONS.includes(ext);
}

/** "Visita 1", "Llamada 2", o "Grabación N" si el tipo no se reconoce. */
export function formatRecordingLabel(rec) {
  const label = TYPE_LABELS[rec?.type] || "Grabación";
  return `${label} ${rec?.index ?? ""}`.trim();
}
